import "@pws/coquille-help-training/styles.css";
import {
  HelpProvider,
  useHelp,
  useHelpOptional,
  HelpButton,
  HelpDrawer,
  PageHelpContent,
} from "@pws/coquille-help-training";
import { injectCoquilleTokens } from "./injectCoquilleTokens.js";

injectCoquilleTokens();

export {
  HelpProvider,
  useHelp,
  useHelpOptional,
  HelpButton,
  HelpDrawer,
  PageHelpContent,
};
